import styled from 'styled-components';

export default styled.div`
    .select-prefix {
        flex: 0 0 80px;
    }
`;
